import React from 'react';
import { BarCustomLayerProps, BarDatum } from '@nivo/bar';

const LINE_STROKE_WIDTH_PX = 2;

type ChartLineProps = Pick<BarCustomLayerProps<BarDatum>, 'bars'>;

/**
 * Capa personalizada de nivo bar que une con una línea los centros de los puntos que
 * dibuja `ChartPoint`, en orden del eje X. Va antes de la capa `bars` para quedar detrás
 * de los puntos y no interceptar su tooltip.
 */
const ChartLine = ({ bars }: ChartLineProps) => {
  if (bars.length < 2) {
    return null;
  }
  const points = [...bars]
    .sort((a, b) => a.x - b.x)
    .map((bar) => `${bar.x + bar.width / 2},${bar.y}`)
    .join(' ');

  return (
    <polyline
      data-testid="chart-line"
      points={points}
      fill="none"
      stroke={bars[0].color}
      strokeWidth={LINE_STROKE_WIDTH_PX}
      strokeLinejoin="round"
      strokeLinecap="round"
      pointerEvents="none"
    />
  );
};

export default ChartLine;
